module.exports = __webpack_public_path__ + "img/brands.52fa593f.jpg";